import React from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import {
  FamilyOrdinancesSkeleton,
  FamilyOrdinancesTabsLayout,
  PersonOrdinanceViewSkeleton,
} from '@fs/zion-person-ordinance-view'
import { usePersonPageParams } from '../personPageRouteUtil'
import { FAMILY_TABS_ONLY_TREATMENT } from './family-ordinances/familyOrdinanceTreatments'
import useFamilyOrdinancesUrlTab from './family-ordinances/useFamilyOrdinancesUrlTab'

export default function OrdinancesTabSkeleton(): JSX.Element {
  const { isOn: showFamilyOrdinances, treatment } = useFeatureFlag('treeWebTx_familyOrdinanceView')
  const { urlTab } = useFamilyOrdinancesUrlTab(usePersonPageParams('full').pid)

  if (showFamilyOrdinances) {
    return (
      <FamilyOrdinancesTabsLayout
        defaultTab={urlTab}
        parents={<FamilyOrdinancesSkeleton />}
        personal={treatment === FAMILY_TABS_ONLY_TREATMENT ? undefined : <PersonOrdinanceViewSkeleton />}
        spouses={<FamilyOrdinancesSkeleton />}
      />
    )
  }
  return <PersonOrdinanceViewSkeleton />
}
